import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { isNil, cloneDeep } from 'lodash-es';
import { ToastrService } from 'ngx-toastr';

import { WavelengthShellService } from 'wavelength-ui';
import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


import { CleanupLoggerService } from './cleanup.logging.service';
import { BarcodeParsing_homeComponent } from './BarcodeParsing.home.component';


@Injectable({ providedIn: 'root' })
export class BarcodeParsing_ShellService extends WavelengthShellService  {
  constructor(
    dialog : MatDialog,
    toastr: ToastrService,
    private $logger: CleanupLoggerService,
  ) {
    super(dialog, toastr);
  }

  public BarcodeParsing: BarcodeParsing_ShellService = this;

  public openhome(replaceCurrentView?: boolean) {
    this.$logger.log('BarcodeParsing', 'home');
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'Home',
        referenceName: 'BarcodeParsing_home',
        component: BarcodeParsing_homeComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openhomeDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    this.$logger.log('BarcodeParsing', 'home');
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      BarcodeParsing_homeComponent,
      'Home',
      mode,
      dialogSize
    )
  }

  public override getComponentInformation(referenceName: string, params: ParamMap): { title: string, component: any, inParams: any } {
    if (referenceName === 'BarcodeParsing_home') {
      this.$logger.log('BarcodeParsing', 'home');
      const title = 'Home';
      const component = BarcodeParsing_homeComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }


    let result = null;
    return result;
  }
}
